import PropTypes from 'prop-types';
import SeverityGroup from './SeverityGroup';

const SeverityGroups = ({ feedback } = {}) => {
  const data = [
    {
      severity: 'warning',
      rowsData: feedback
    }
  ];

  return data?.map(SeverityGroup);
};

SeverityGroups.propTypes = {
  feedback: PropTypes.array
};

export default SeverityGroups;
